import React, { useState,  useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import '../PatientInfo.scss';

export default function PatientInfo_Demographics(props) {
 
  const [model, setModel] = useState(props.model);

  const onChange = (fieldName, value) => {
    let obj = {};
    obj[fieldName] = value;
    setModel({...model, ...obj});
    props.onChange(fieldName, value);
  };
  
  const item = (fieldName, fieldValue, fieldLabel) => {
    let locked = props.isLocked(fieldName);
    const isSendSMS = fieldName === "dSendSMS";

    return (
            <Grid item xs={12} sm={6} className={`lockable ${locked ? "locked" : ""}`}>
              <FormControl fullWidth>
                <InputLabel id={fieldName}>{fieldLabel}</InputLabel>
                <Select
                  labelId={fieldName}
                  id={fieldName}
                  value={fieldValue ?? -1} 
                  disabled={locked}
                  onChange={e => {
                    onChange(fieldName, e.target.value);
                  }}
                >
                {!isSendSMS && <MenuItem value={0}>Desired {locked && <Icon>lock</Icon>}</MenuItem>}
                <MenuItem value={-1}>Don't Ask {locked && <Icon>lock</Icon>}</MenuItem>
                <MenuItem value={1}>Required {locked && <Icon>lock</Icon>}</MenuItem>
                 
                </Select>
              </FormControl>
            </Grid>
    );
  };

  const itemX = (fieldName, fieldValue, fieldLabel, textName, textValue) => {
    const lockedSelect = props.isLocked(fieldName);
    const lockedText = props.isLocked(textName);

    return(
      <>
        <Grid item xs={12} sm={6} className={`lockable ${lockedSelect ? "locked" : ""}`}>
          <FormControl fullWidth>
            <InputLabel id={fieldName}>{fieldLabel}</InputLabel>
            <Select
              labelId={fieldName}
              id={fieldName}
              value={fieldValue ?? -1}
              disabled={lockedSelect}
              onChange={e => {
                onChange(fieldName, e.target.value);
              }}
            >
              <MenuItem value={-1}>Don't Ask {lockedSelect && <Icon>lock</Icon>}</MenuItem>
              <MenuItem value={1}>Required {lockedSelect && <Icon>lock</Icon>}</MenuItem>

            </Select>
          </FormControl>
        </Grid>

        <Grid item xs={12} sm={6} className={`lockable ${lockedText ? "locked" : ""}`}>
          <TextField
            label={`${fieldLabel} Link`}
            value={textValue  ?? ""}
            fullWidth
            disabled={lockedText}
            onChange={e => {
              onChange(textName, e.target.value);
            }}
            required={fieldValue === 1}
            inputProps={{ maxLength: 50 }}
          />
        </Grid>
      </>
    )
  }

  useEffect(() => {
    setModel(props.model);
  }, [props.model]);

  return (
      <div>
        <h3>Patient Information</h3>

        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dEmail", model.dEmail, "Email")}
          {item("dCellPhone", model.dCellPhone, "Cell Phone Number")}
        </Grid>   
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("ddob", model.ddob, "Date of Birth")}
          {item("dHomePhone", model.dHomePhone, "Home Phone Number")}
        </Grid> 
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dL4DSSN", model.dL4DSSN, "Last 4 of SS#")}
          {item("dWorkPhone", model.dWorkPhone, "Work Phone Number")}
        </Grid> 
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dGender", model.dGender, "Gender")}
          {item("dPrefLang", model.dPrefLang, "Language")}
        </Grid> 
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dAddress1", model.dAddress1, "Address 1")}
          {item("dAddress2", model.dAddress2, "Address 2")}
        </Grid> 
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dCity", model.dCity, "City")}
          {item("dState", model.dState, "State")}
        </Grid> 
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dZip", model.dZip, "Zip")}
          {item("dReferredBy", model.dReferredBy, "Referred By")}
        </Grid>
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {item("dSendSMS", model.dSendSMS, "Send SMS")}
        </Grid>
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {itemX("dTermsOfService", model.dTermsOfService, "Terms of Service", "dTermsOfServiceLbl", model.dTermsOfServiceLbl)}
        </Grid>
        <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={3}>
          {itemX("dPrivacyPolicy", model.dPrivacyPolicy, "Privacy Policy", "dPrivacyPolicyLbl", model.dPrivacyPolicyLbl)}
        </Grid>
      </div>
      );
};

